module.exports = __webpack_public_path__ + "img/info.6506137a.svg";